import { ALERT_TYPE, AlertComponent } from '@abiglobalhealth/go-types'
import { useTranslation } from 'react-i18next'

import NegativeAlert from '@/assets/icons/negative-alert.svg'
import PositiveAlert from '@/assets/icons/positive-alert.svg'

const ALERT_STYLES = {
  [ALERT_TYPE.NEGATIVE]: {
    borderColor: 'border-alert-error',
    icon: NegativeAlert
  },
  [ALERT_TYPE.POSITIVE]: {
    borderColor: 'border-success',
    icon: PositiveAlert
  }
}

export type AlertProps = Omit<AlertComponent, 'componentType'>

export const Alert = ({ id, textKey, type }: AlertProps) => {
  const { t } = useTranslation()

  return (
    <div
      id={id}
      data-testid={`${id}-container`}
      className={`bg-gray-background flex flex-col gap-3 rounded-2xl border p-6 shadow-sm ${ALERT_STYLES[type].borderColor}`}
    >
      <img src={ALERT_STYLES[type].icon} className="mx-auto" />
      <p className="text-center font-bold">{t(textKey)}</p>
    </div>
  )
}
